export const CHART_HEIGHT = 240;
export const CHART_MARGIN = { left: 0, top: 10, right: 0, bottom: 0 };
export const XAXIS_HEIGHT = 24;
export const BAR_GAP = 10.6;
export const BAR_MIN_WIDTH = 107;
export const BAR_MIN_HEIGHT = 64;
export const BORDER_RADIUS = 8;
export const BAR_DASH_PADDING = 8;
export const BAR_DASH_HEIGHT = 8;
export const ANIMATION_DURATION = 1000;
